import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const AboutUSParaContentComp = () => {
  return (
    <section className="py-5">
      <Container>
        <Row>
          <Col xs={12} sm={12} md={5}>
            <h2 className="">
              Zero trust is a security principle Zero2Infynite is your
              transformation principle
            </h2>
          </Col>
          <Col xs={12} sm={12} md={7}>
            <p>
              At Zero2Infynite, we are more than just a cybersecurity training
              company — we are your gateway to a secure digital future. Our
              mission is to transform passionate learners into skilled
              professionals, guiding them from zero knowledge to infinite
              potential in the ever-evolving world of cybersecurity.
            </p>
            <p>
              We evaluate each student's unique needs and provide personalized
              guidance. Unlike typical institutes that stop at training, we
              offer continuous support until you reach your objectives. We are
              an authorized EC-Council Accredited Training Center (ATC) partner.
              We take pride in our 100% pass rate for international
              certifications—something you may not get if you purchase courses
              directly or through other providers.
            </p>
            <p>
              Our trainers bring real-world industry experience and also assist
              with job referrals. They have designed cybersecurity course
              syllabi for prestigious institutions such as SRM Valliammai
              Engineering College, St. Joseph's College, and others. We also
              hold MOUs with top colleges including VIT Chennai, St. Joseph's,
              SRM, and VELS University.
            </p>
            <p>
              We offer comprehensive, hands-on training programs designed by
              industry experts, tailored to meet real-world demands. Whether
              you're a beginner or an experienced professional, our curriculum
              ensures you gain the technical expertise, critical thinking, and
              practical skills needed to thrive in today's threat landscape.
            </p>
            <p>
              But we don't stop at training. Our robust placement assistance
              connects you with top employers, helping you land roles in
              penetration testing, security operations, compliance, cloud
              security, and more. Additionally, we offer professional
              cybersecurity services to businesses, securing digital
              infrastructures with advanced threat detection, incident response,
              and risk management solutions.
            </p>
            <p>
              We have successfully placed the majority of our students in the
              cybersecurity field. Additionally, we've helped experienced
              professionals transition into cybersecurity by carefully assessing
              and building on their existing skills. We've also supported
              working cybersecurity professionals in earning international
              certifications to boost their skills, salaries, and career
              positions.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUSParaContentComp;
